import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { ERTUser } from "../../../interfaces/ert-user/ert-user";
import { ActivatedRoute, Router } from "@angular/router";
import { Kr998Service } from "../../../services/kr998/kr998.service";
import { ERTUserService } from "../../../services/ert-user/ert-user.service";
import { MatSort } from "@angular/material/sort";
import { PicklistItem } from "../../../shared/picklist/picklist-select.component";
import { Ikr998ErtUsers } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998ertusers";
import { Kr998ErtUsersService } from "../../../services/kr998ErtUsers/kr998ErtUsers.service";
import { IPicklistValuesData } from "../../../interfaces/administration/picklistValuesData";
import { PicklistService } from "../../../services/administration/picklist/picklist.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoggedUserService } from "../../../services/common/logged-user.service";

@Component({
  selector: "app-new-kr998-add-crew",
  templateUrl: "./new-kr998-add-crew.component.html",
})
export class NewKr998AddCrewComponent implements OnInit {
  kr998Form: FormGroup;
  totalItems: number;
  selectedCount: number = 0;
  dataSource = new MatTableDataSource<ERTUser>();
  selectedCrewItem!: PicklistItem;
  users: ERTUser[] = [];
  crewUsers: ERTUser[] = [];
  instructors: ERTUser[] = [];
  selectedUsers: number[] = [];
  krId: number = 0;
  showMessage: boolean = false;

  displayedColumns: Map<string, string> = new Map<string, string>([
    ["select", ""],
    ["cai", "Email"],
    ["fullName", "Full Name"],
    ["crew", "Crew"],
    ["unit", "Unit"],
  ]);
  displayedColumnsArray: string[] = Array.from(this.displayedColumns.keys());
  @ViewChild(MatSort) sort: MatSort;
  crewFieldId: number;
  unitFieldId: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private kr998Service: Kr998Service,
    private ertUserService: ERTUserService,
    private kr998ErtUsers: Kr998ErtUsersService,
    private pickListsService: PicklistService,
    private fb: FormBuilder,
    private loggedUserService: LoggedUserService
  ) {
    this.kr998Form = this.fb.group({
      crew: [""],
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnInit(): void {
    this.krId = +this.route.snapshot.paramMap.get("id")!;

    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      const facilityId = Number(user?.facilityId) || 1;
      this.ertUserService
        .getUsersAndInstructors(facilityId)
        .subscribe((data) => {
          this.users = data.users.filter((user) => !user.isInstructor);
          this.dataSource.data = this.users;
          this.totalItems = this.users.length;
        });
    });

    this.pickListsService.getFieldIdByName("Crew").subscribe((crewFieldId) => {
      if (crewFieldId) this.crewFieldId = crewFieldId;
    });
    this.pickListsService.getFieldIdByName("Units").subscribe((unitFieldId) => {
      if (unitFieldId) this.unitFieldId = unitFieldId;
    });
  }

  onCrewSelected(item: PicklistItem) {
    if (item.id === "-1") {
      this.selectedCrewItem = null;
      this.kr998Form.get("crew")?.setValue("");
      this.showMessage = false;
    } else {
      this.selectedCrewItem = item;
      this.getUsersBySelectedCrew(item.id);
      this.updateShowMessage();
    }
  }

  toggleSelection(userId: number): void {
    if (this.selectedUsers.includes(userId)) {
      this.selectedUsers = this.selectedUsers.filter((id) => id !== userId);
    } else {
      this.selectedUsers.push(userId);
    }
    this.selectedCount = this.selectedUsers.length;
    this.updateShowMessage();
  }

  toggleAllSelection(event: any): void {
    if (event.checked) {
      this.selectedUsers = this.users.map((user) => user.id);
    } else {
      this.selectedUsers = [];
    }
    this.selectedCount = this.selectedUsers.length;
    this.updateShowMessage();
  }

  updateShowMessage(): void {
    this.showMessage = !!this.selectedCrewItem && this.selectedUsers.length > 0;
    if (!this.selectedCrewItem && this.selectedUsers.length === 0) {
      this.showMessage = false;
    }
  }

  getUsersBySelectedCrew(crewValue: string) {
    this.ertUserService.getUsersByCrewValueId(crewValue).subscribe((data) => {
      this.crewUsers = data;
      this.instructors = this.crewUsers.filter((user) => user.isInstructor);
      this.crewUsers = this.crewUsers.filter((user) => !user.isInstructor);

      this.updateShowMessage();
    });
  }

  addUserOrCrew() {
    const kr998ErtUsers = [];
    if (this.crewUsers.length > 0) {
      this.crewUsers.forEach((user) => {
        kr998ErtUsers.push({
          kr998DetailsId: 0,
          userErtId: user.id,
          kr998Id: this.krId,
          isInstructior: false,
          instructorAtTimeOfClass: false,
          hours: 0,
          attendanceType: 0,
          attendanceStatus: 0,
          userErt: null,
          kr998: null,
        });
      });
    } else if (this.instructors.length > 0) {
      this.instructors.forEach((user) => {
        kr998ErtUsers.push({
          kr998DetailsId: 0,
          userErtId: user.id,
          kr998Id: this.krId,
          isInstructior: true,
          instructorAtTimeOfClass: false,
          hours: 0,
          attendanceType: 0,
          attendanceStatus: 0,
          userErt: null,
          kr998: null,
        });
      });
    } else if (this.selectedUsers.length > 0) {
      const data: Ikr998ErtUsers[] = this.selectedUsers.map((userId) => ({
        kr998DetailsId: 0,
        userErtId: userId,
        kr998Id: this.krId,
        isInstructior: false,
        instructorAtTimeOfClass: false,
        createdDate: null,
        hours: 0,
        attendanceType: 0,
        attendanceStatus: 0,
        userErt: null,
        kr998: null,
      }));
      kr998ErtUsers.push(...data);
    }
    this.kr998ErtUsers.createKr998ErtUsers(kr998ErtUsers).subscribe({
      next: () => {
        this.router.navigate(["/ert-kr998/ert-kr998-view", this.krId]);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getLastPostedCrew(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.ertUserService.getValueForField(
      picklistValues,
      this.crewFieldId
    );
    return name;
  }

  getLastPostedUnit(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.ertUserService.getValueForField(
      picklistValues,
      this.unitFieldId
    );
    return name;
  }
  onCancel() {
    this.router.navigate(["/ert-kr998/ert-new-kr998"]);
  }
}
